import { useState, useContext } from "react";
import Modal from "components/global/modal";
import Button from "components/button/button";
import LoadingIndicator from "assets/svg/loading-indicator";
import { AiFillDelete, AiFillWarning } from "react-icons/ai";
import Input from "components/input/input";
import { SubscriptionContext } from "context/subscription";
import toast from "react-hot-toast";

const Password = ({
    hide,
    userData
})=>{
    const { http } = global.services;
    const [state,setState] = useState({
        password: "",
        showPassword:false,
        validationErrors:{}

    });
    const [submitLoading, setSubmitLoading] = useState(false);
    const { isSubscribed, subscription } = useContext(SubscriptionContext);

    const confirmDelete = async()=>{

        const {user} = userData;
        try {
            setSubmitLoading(true);
            const { data } = await http.delete(`public/user/${user.id}`,{
                password:state.password
            });
            // Confirmation that comes up on screen (persists across the logout
            // redirect via the app-level toaster). (Marker.io MCF-993)
            toast.success(data?.message || "Your account has been deleted.");
            hide({ data, success: true });
          } catch (err) {
            console.log("error@delete", err);
            const {data} = err;
            setSubmitLoading(false);
            setState((prev) => ({
            ...prev,
            validationErrors: { ...state.validationErrors, password: data.error },
            }));
          } finally {
            setSubmitLoading(false);
          }
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setState((prev) => ({
        ...prev,
        [name]: value,
        validationErrors: { ...state.validationErrors, [name]: null },
        }));
    };

    const isLifetime = userData?.user?.reg_status=='freemium'||userData?.user?.reg_status=='lifetime'

    return (
        <>
        <Modal 
            width="w-19/20 md:w-16/20 2md:w-12/20 3md:w-1/3 1xl:w-8/20"
            contentClassName="rounded-lg overflow-auto custom-scroll"
            wrapperClassName="overflow-visible"
            footerClass="border-t border-gray">
              {
                isSubscribed && !isLifetime ? (
                  <>
                    <div className="w-full">
                      {/* header */}
                      <div className="px-8.5 py-2 mt-4 flex gap-2 items-center">
                        <div className="text-red text-xl"><AiFillWarning/></div>
                        <h1 className="text-xl font-bold text-red">Unsubscribe First</h1>
                      </div>
                      <div className="px-8.5 py-2 mb-2">
                        <h1>You need to unsubscribe first before you can delete your account</h1>
                      </div>
                    </div>
                    <div className="w-full flex items-center justify-start 1sm:justify-end space-x-2 border-t border-gray pt-4 py-4 pr-4">
                      <Button
                        buttonName="close"
                        buttonClass="bg-thBg py-4 px-8 hover:bg-gray"
                        buttonTextClass="text-black text-sm font-semibold"
                        onClick={hide}
                      />
                    </div>
                  </>
                ):
                  <>
                    <div className="w-full">
                      {/* header */}
                      <div className="px-8.5 py-2 mt-4 flex gap-2 items-center">
                        <div className="text-red text-xl"><AiFillDelete/></div>
                        <h1 className="text-xl font-bold text-red">Confirm to delete </h1>
                      </div>
                      <div className="px-8.5 py-2 mb-2">
                        <h1>Are you sure you want to delete your account?</h1>
                        <Input
                          inputContainerClass="form-input-container"
                          value={state.password}
                          outsideLabel="Password"
                          outsideLabelClass="text-xs 1xs:text-sm font-bold text-darkerGray"
                          noLabelPaddingY="1rem"
                          name="password"
                          masked={true}
                          visible={state.showPassword}
                          onChangeVisible={() =>
                            setState((prev) => ({
                              ...prev,
                              showPassword: !prev.showPassword,
                            }))
                          }
                          type={state.showPassword ? "text" : "password"}
                          onChange={handleInputChange}
                          errorMessage={state.validationErrors?.password}
                        />
                      </div>
                    </div>
                    <div className="w-full flex items-center justify-start 1sm:justify-end space-x-2 border-t border-gray pt-4 py-4 pr-4">
                      <Button
                        buttonName="Cancel"
                        buttonClass="bg-thBg py-4 px-8 hover:bg-gray"
                        buttonTextClass="text-black text-sm font-semibold"
                        onClick={hide}
                      />
                      <Button
                        key="save-btn-category"
                        buttonName="Submit"
                        buttonClass="relative py-4 px-9 bg-red"
                        buttonTextClass="text-white text-sm font-semibold flex items-center"
                        onClick={confirmDelete}
                        disabled={state.password.length <= 0}
                        loadingIcon={
                          submitLoading ? (
                            <LoadingIndicator className="text-white w-4 h-4 ml-2" />
                          ) : null
                        }
                      />
                    </div>
                  </>
              }

            </Modal>
        </>
    )
}

export default Password;